import React, { useEffect, createElement } from 'react';
export function GoogleTag() {
  useEffect(() => {
    // Create the first script element (the async one)
    const firstScript = document.createElement('script');
    firstScript.async = true;
    firstScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17280398483';
    // Create the second script element (the inline one)
    const secondScript = document.createElement('script');
    secondScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17280398483');
    `;
    // Append both scripts to the document head
    document.head.appendChild(firstScript);
    document.head.appendChild(secondScript);
    // Cleanup function to remove scripts when component unmounts
    return () => {
      if (document.head.contains(firstScript)) {
        document.head.removeChild(firstScript);
      }
      if (document.head.contains(secondScript)) {
        document.head.removeChild(secondScript);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything
}